import React from 'react'

import { months } from '../../models/Months.model'

type CalculatorDateFieldsProps = {
  startMonth: number
  startDay: number
  startYear: number
  validMonths: number[]
  validYears: number[]
  validDays: number
  validationError?: string
  onMonthChange: (month: number) => void
  onDayChange: (day: number) => void
  onYearChange: (year: number) => void
}

export const CalculatorDateFields: React.FC<CalculatorDateFieldsProps> = ({
  startMonth,
  startDay,
  startYear,
  validMonths,
  validYears,
  validDays,
  validationError,
  onMonthChange,
  onDayChange,
  onYearChange,
}) => {
  return (
    <div className="md:col-span-2">
      <label className="mb-1.5 block text-xs font-semibold text-graphite-grey sm:text-sm">Start Date</label>
      <div className="flex gap-2 sm:gap-3">
        <select
          name="start-month"
          className="flex-1 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-royal-indigo sm:px-4"
          value={startMonth}
          onChange={(evt) => onMonthChange(Number(evt.target.value))}
        >
          {months.map((month, monthIndex) => {
            const monthValue = monthIndex + 1
            if (!validMonths.includes(monthValue)) {
              return null
            }
            return (
              <option key={month} value={monthValue}>
                {month}
              </option>
            )
          })}
        </select>
        <select
          name="start-day"
          className="flex-1 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-royal-indigo sm:px-4"
          value={startDay}
          onChange={(evt) => onDayChange(Number(evt.target.value))}
        >
          {[...Array(validDays)].map((_, index) => (
            <option key={'date_' + index} value={index + 1}>
              {index + 1}
            </option>
          ))}
        </select>
        <select
          name="start-year"
          className="flex-1 rounded-lg border border-gray-300 bg-white px-3 py-2.5 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-royal-indigo sm:px-4"
          value={startYear}
          onChange={(evt) => onYearChange(Number(evt.target.value))}
        >
          {validYears.map((year) => (
            <option key={'year_' + year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      {validationError && (
        <div className="validation-error mt-1 text-sm text-red-500" tabIndex={-1}>
          {validationError}
        </div>
      )}
    </div>
  )
}
